export default {"src":"/_next/static/media/search.9197ce09.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};